/**
 * Type slice selectors conservatively, so they only require the part of the state that is relevant to the slice.
 */
export function createSliceSelector(slice) {
    return (state) => state[slice.name];
}
